export default __webpack_public_path__ + "static/media/mon_rotated.f206ffe6.png";